import { all, call, put, takeEvery, select } from 'typed-redux-saga';
import { PayloadAction } from '@reduxjs/toolkit';

import { getRegionSetting } from 'src/selectors';
import { uploadImageAndGetSize } from 'src/util/upload';
import { uploadDocumentImage, uploadDocumentImageSuccess, uploadDocumentImageFailed } from './slice';
import { getSdk } from 'src/sdk';

function* uploadImageForAllDocuments({ payload }: PayloadAction<File>): Generator<any, void, any> {
    const region = yield* select(getRegionSetting);
    try {
        const { url } = yield* call(uploadImageAndGetSize, getSdk(), payload, region);
        yield* put(uploadDocumentImageSuccess({ url, fileName: payload.name }));
    } catch (error: any) {
        yield* put(uploadDocumentImageFailed());
    }
}

export default function* canvasSaga() {
    return yield* all([yield* takeEvery(uploadDocumentImage, uploadImageForAllDocuments)]);
}
